// extracted by mini-css-extract-plugin
export default {"c-notification":"lAg3q","exit-active":"VY7mN","enter":"FWLgC","enter-active":"ZxzO8","c-notification__action":"wHahS","notifications":"zVtJM"};